// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/state-machines/notification-machine.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/state-machines/src/notification-machine.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo agape-church-app
//     node fleet/fleet.ts check --repo agape-church-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { assign, setup } from "xstate";

type NotificationType = "success" | "error" | "warning" | "info";

interface Notification {
  id: string;
  type: NotificationType;
  message: string;
  duration?: number;
}

type NotificationEvent =
  | { type: "NOTIFY"; notification: Omit<Notification, "id"> }
  | { type: "DISMISS"; id: string }
  | { type: "CLEAR_ALL" };

interface NotificationContext {
  notifications: Notification[];
}

const RANDOM_ID_BASE = 36;
const RANDOM_ID_SLICE = 7;

export const notificationMachine = setup({
  // Schema Definition Pattern for XState v5 type inference
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  types: {} as {
    context: NotificationContext;
    events: NotificationEvent;
  },
  actions: {
    addNotification: assign({
      notifications: ({ context, event }) => {
        if (event.type !== "NOTIFY") {
          return context.notifications;
        }
        const newNotification: Notification = {
          ...event.notification,
          id: Math.random().toString(RANDOM_ID_BASE).slice(RANDOM_ID_SLICE),
        };
        return [...context.notifications, newNotification];
      },
    }),
    removeNotification: assign({
      notifications: ({ context, event }) => {
        if (event.type !== "DISMISS") {
          return context.notifications;
        }
        return context.notifications.filter((n) => n.id !== event.id);
      },
    }),
    clearAll: assign({
      notifications: [],
    }),
  },
}).createMachine({
  id: "notification",
  initial: "idle",
  context: {
    notifications: [],
  },
  on: {
    NOTIFY: {
      actions: "addNotification",
    },
    DISMISS: {
      actions: "removeNotification",
    },
    CLEAR_ALL: {
      actions: "clearAll",
    },
  },
  states: {
    idle: {},
  },
});
